import ArticleEditor from "%/dynamic-component-editor/standard-pages/edit-article-page/elements/ArticleEditor.vue";
import ArticleTitleInput from "%/dynamic-component-editor/standard-pages/edit-article-page/elements/ArticleTitleInput.vue";
import ArticleHashtagInput from "%/dynamic-component-editor/standard-pages/edit-article-page/elements/ArticleHashtagInput.vue";
import PublishArticleButton from "%/dynamic-component-editor/standard-pages/edit-article-page/elements/PublishArticleButton.vue";
import SavingStatus from "%/dynamic-component-editor/standard-pages/edit-article-page/elements/SavingStatus.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyEditArticle extends LegacyEntity {
  get elements() {
    return {
      ArticleEditor,
      ArticleTitleInput,
      ArticleHashtagInput,
      PublishArticleButton,
      SavingStatus,
    };
  }
}
